import * as endpoints from "../data/links/endpoints";
import { api } from "./api";

export async function getUser({ signal }) {
  return api
    .get(endpoints.GET_USER, { signal })
    .then((res) => res.data.user)
    .catch((error) => {
      if (error.response.status === 500) {
        return;
      }
    });
}

export async function getSettings({ signal }) {
  return api
    .get(endpoints.GET_SETTINGS, { signal })
    .then((res) => res.data.settings)
    .catch((error) => error);
}

export async function getAthleteProfile({ userId, signal }) {
  if (!userId) return;
  return api
    .get(endpoints.GET_ATHLETE_PROFILE + userId, { signal })
    .then((res) => res.data.profile)
    .catch((error) => {
      if (error.message === "canceled") return;
      console.log(error);
    });
}

export async function getUsersStatistics({ signal }) {
  return api
    .get(endpoints.USERS_STATISTICS, { signal })
    .then((res) => res.data)
    .catch((error) => console.log(error));
}

export async function getAthleteLifts({ signal }) {
  return api
    .get(endpoints.GET_USER_LIFTS, { signal })
    .then((res) => res.data.lifts)
    .catch((error) => console.log(error));
}

export async function getAthleteCardio({ signal }) {
  return api
    .get(endpoints.GET_USER_CARDIO, { signal })
    .then((res) => res.data.cardio)
    .catch((error) => console.log(error));
}

export async function getAthleteGymnastics({ signal }) {
  return api
    .get(endpoints.GET_USER_GYMNASTICS, { signal })
    .then((res) => res.data.gymnastics)
    .catch((error) => console.log(error));
}

export async function getUsersBiometrics({ signal }) {
  return api
    .get(endpoints.GET_USER_BIOMETRICS, { signal })
    .then((res) => res.data)
    .catch((error) => console.log(error));
}

// export async function checkUserStreak({ signal }) {
//   return api
//     .get(endpoints.CHECK_USER_STREAK, { signal })
//     .then((res) => res.data)
//     .catch((error) => console.log(error));
// }

export async function updateAthleteProfile(data) {
  let { countryId, level, user_box, user_height } = data;

  let body = {
    country_id: countryId,
    level,
    box: user_box,
    height: user_height,
  };

  return api.post(endpoints.UPDATE_PROFILE, body).then((res) => res);
}

export async function completeProfile(data) {
  let {
    countryId,
    level,
    user_weight,
    user_height,
    user_box,
    bday,
    gender,
    timezone,
  } = data;

  let body = {
    country_id: countryId,
    level,
    bday,
    box: user_box,
    gender,
    height: user_height,
    weight: user_weight,
    timezone,
  };

  return api.post(endpoints.COMPLETE_PROFILE, body).then((res) => res);
}

export async function editAthleteAbilities({
  type,
  exerciseId,
  score,
  distance,
  fileId,
}) {
  let data = {
    type,
    exercise_id: exerciseId,
    score,
    file_id: fileId,
  };

  if (type === "cardio") data["distance"] = distance;
  return api.post(endpoints.EDIT_ABILITIES, data).then((res) => res);
}

export async function updateProfilePicture({ uploadData }) {
  return api
    .post(endpoints.UPDATE_PROFILE_PICTURE, uploadData)
    .then((res) => res);
}

export async function insertBiometricData(data) {
  return api.post(endpoints.INSERT_BIOMETRIC_DATA, data).then((res) => res);
}

export async function saveSettings(data) {
  let { distanceUnitId, heightUnitId, weightUnitId, excluded } = data;
  let body = {
    weight_unit_id: weightUnitId,
    height_unit_id: heightUnitId,
    distance_unit_id: distanceUnitId,
    excluded_exercises: JSON.stringify(excluded),
  };
  return api.post(endpoints.SAVE_SETTINGS, body).then((res) => res);
}

export async function getExerciseProgress(data) {
  let { exerciseId, distance, category } = data;
  let body = new FormData();

  if (!exerciseId) return;

  body.append("category", category);
  body.append("exercise_id", exerciseId);
  if (category === "cardio") body.append("distance", distance);

  return api.post(endpoints.GET_EXERCISE_PROGRESS, body).then((res) => res);
}

export async function entryPostedToday(data) {
  let { exerciseId, distance, type, wodId } = data;
  let body = new FormData();

  body.append("type", type);
  if (type === "cardio" || type === "weightlifting" || type === "gymnastics") {
    body.append("exercise_id", exerciseId);
    if (type === "cardio") {
      body.append("distance", distance);
    }
  }

  if (type === "score") body.append("wod_id", wodId);

  return api.post(endpoints.CHECK_ENTRY_POSTED_TODAY, body).then((res) => res);
}

export async function getUsersNotifications({ signal }) {
  return api
    .get(endpoints.GET_USERS_NOTIFICATIONS, { signal })
    .then((res) => res.data.notifications)
    .catch((error) => console.log(error));
}

export async function readNotification({ notification_id }) {
  if (!notification_id) return;
  let body = { notification_id };
  return api.post(endpoints.READ_NOTIFICATION, body).then((res) => res);
}

export async function getUserActivity({ type, signal }) {
  return api
    .get(endpoints.GET_USER_ACTIVITY + type, { signal })
    .then((res) => res.data)
    .catch((error) => console.log(error));
}

export async function getWoWStatistics({ signal }) {
  return api
    .get(endpoints.GET_WOW_STATISTICS, { signal })
    .then((res) => res.data)
    .catch((error) => console.log(error));
}

export async function getWoWPlaces({ signal }) {
  return api
    .get(endpoints.GET_WOW_PLACES, { signal })
    .then((res) => res.data.standings)
    .catch((error) => console.log(error));
}

export async function deleteAccount(data) {
  return api.post(endpoints.DELETE_USER_ACCOUNT, data).then((res) => res);
  // .catch((error) => error.response);
}

export async function sendDeleteAccountRequest({ signal }) {
  return api
    .get(endpoints.DELETE_ACCOUNT_REQUEST, { signal })
    .then((res) => res)
    .catch((error) => error.response);
}

export async function getUserAchievements({ signal }) {
  return api
    .get(endpoints.GET_USER_ACHIEVEMENTS, { signal })
    .then((res) => res.data.user_achievements)
    .catch((error) => error.response);
}

export async function getAthletesToChallenge({ signal }) {
  return api
    .get(endpoints.GET_ATHLETES_BY_FILTERS, { signal })
    .then((res) => res.data.athletes)
    .catch((error) => error.response);
}

export async function challengeAthlete({ athleteId, workoutId }) {
  let body = {
    athlete_id: athleteId,
    workout_id: workoutId,
  };

  return api
    .post(endpoints.CHALLENGE_ATHLETE, body)
    .then((res) => res)
    .catch((error) => error.response);
}

export async function getAthleteChallenges({ signal }) {
  return api
    .get(endpoints.GET_ATHLETE_CHALLENGES, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}
